// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7072) return "static/chunks/a0cf267f-ba37919e9e19cf5e.js";
	if (chunkId === 4830) return "static/chunks/4830-796729433d7b0a3a.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"8979":"0af98a8b","8985":"7aeec5c9"}[chunkId] || chunkId) + "." + {"1092":"c5a4afd25165e28c","1640":"0cfbd9d631862d1f","2234":"5dbbc4769254867d","3893":"e113694708bc77e1","6716":"d618c0bde007d33a","8979":"eb004562092295ba","8985":"616c45799c6b0762"}[chunkId] + ".js";
};